import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiKeysService } from '../services';

/**
 * Hook para desativar uma API Key
 *
 * @example
 * const { mutate: deactivateKey, isPending } = useDeactivateApiKey();
 *
 * const handleDeactivate = () => {
 *   deactivateKey(keyId);
 * };
 */
export const useDeactivateApiKey = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => ApiKeysService.deactivateApiKey(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['api-keys'] });
    },
  });
};
